import React from 'react';
import TimeRangeSelector from './TimeRangeSelector';
import ViewControls from './ViewControls';
import { TimeRangeProvider } from '../../context/TimeRangeContext';
import { useParams } from 'react-router-dom';

interface TimeSeriesDataProps {
  timeseriesChartData: any;
  retrieveMinMax: boolean;
  openAddTaskModal: (status: true) => void;
  fetchCov: boolean;
  aggegateMethod: string;
  openAddNoteModal: (status: true) => void;
  layout: string;
  isEditYAxisOpen?: boolean;
  setIsEditYAxisOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  setYAxisRefreshVersion?: React.Dispatch<React.SetStateAction<number>>;
  disableViewControls?: boolean;
  disableTimeRangeSelector?: boolean;
  enableRefreshOnTimeRangeSelector?: boolean;
  accessible?: boolean;
  rPermission: { [key: string]: boolean; };
}
const Header: React.FC<TimeSeriesDataProps> = ({
  timeseriesChartData,
  retrieveMinMax,
  openAddTaskModal,
  fetchCov,
  aggegateMethod,
  openAddNoteModal,
  layout,
  isEditYAxisOpen,
  setIsEditYAxisOpen,
  setYAxisRefreshVersion,
  disableViewControls,
  disableTimeRangeSelector,
  enableRefreshOnTimeRangeSelector,
  accessible,
  rPermission,
}) => {
  const { assetId } = useParams<{ assetId: string }>();
  return (
    <header className={'chart-header' + (!accessible ? ' disable-events' : '')} >
      <TimeRangeProvider>
        {!disableTimeRangeSelector && (
          <TimeRangeSelector
            timeseriesChartData={timeseriesChartData}
            assetId={assetId}
            retrieveMinMax={retrieveMinMax}
            fetchCov={fetchCov}
            aggregateMethod={aggegateMethod}
            layout={layout}
            enableRefreshOnTimeRangeSelector={enableRefreshOnTimeRangeSelector}
          />
        )}
        {!disableViewControls && (
          <ViewControls
            openAddTaskModal={openAddTaskModal}
            timeseriesChartData={timeseriesChartData}
            assetId={assetId}
            retrieveMinMax={retrieveMinMax}
            fetchCov={fetchCov}
            openAddNoteModal={openAddNoteModal}
            selectedOption={layout}
            isEditYAxisOpen={isEditYAxisOpen}
            setIsEditYAxisOpen={setIsEditYAxisOpen}
            setYAxisRefreshVersion={setYAxisRefreshVersion}
            rPermission={rPermission}
          />
        )}
      </TimeRangeProvider>
    </header>
  );
};

export default Header;
